import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

export const BgColor = {
  WHITE: 'surface',
  SECONDARY: 'surface-secondary',
  TERTIARY: 'surface-tertiary',
  CAUTION: 'caution',
  INFO: 'info'
} as const
export type BgColor = (typeof BgColor)[keyof typeof BgColor]

interface Props extends ChildProps {
  color?: BgColor
  border?: boolean | 'emphasis'
  fit?: boolean
  type?: 'default' | 'thin'
}

const bgColorClass = (color: BgColor) => {
  switch (color) {
    case BgColor.WHITE:
      return 'bg-surface'
    case BgColor.SECONDARY:
      return 'bg-surface-secondary'
    case BgColor.TERTIARY:
      return 'bg-fill-surface-tertiary'
    case BgColor.CAUTION:
      return 'bg-caution'
    case BgColor.INFO:
      return 'bg-info'
  }
}

const InsideArea = ({
  children,
  color = BgColor.WHITE,
  border = false,
  fit = false,
  type = 'default'
}: Props) => {
  return (
    <div
      className={clsx(
        `rounded-lg`,
        bgColorClass(color),
        border && (border == 'emphasis' ? 'border-ruri-600 border' : `border-primary border`),
        fit ? `w-fit` : 'w-full',
        type === 'thin' ? 'px-4 py-2' : 'px-4 py-3'
      )}
    >
      {children}
    </div>
  )
}

export default InsideArea
